module.exports = "<p\n  *ngIf=\"authService.successfulActivation == null\">\n  Checking credentials, please wait.\n</p>\n<p\n  *ngIf=\"authService.successfulActivation\"\n  class=\"alert alert-success\">\n  Account successfully activated.\n</p>\n<p\n  *ngIf=\"authService.successfulActivation === false\"\n  class=\"alert alert-danger\">\n  Something went wrong, please try again.\n</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account-activation/account-activation.component.html
// module id = 743
// module chunks = 1